'use strict';

var React = require('react');

var SvgStoreMajor = function SvgStoreMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.482 3.5c.418 0 .809.209 1.04.557l1.768 2.651c.137.205.21.447.21.693v.849c0 .854-.39 1.617-1 2.121v4.379a1.75 1.75 0 0 1-1.75 1.75h-7.5a1.75 1.75 0 0 1-1.75-1.75v-4.379c-.61-.504-1-1.267-1-2.121v-.849c0-.246.073-.488.21-.693l1.768-2.651a1.25 1.25 0 0 1 1.04-.557h6.964Zm-6.83 1.5-1.652 2.477v.773a1.25 1.25 0 1 0 2.5 0v-.5a.75.75 0 0 1 1.5 0v.75a1 1 0 0 0 2 0v-.75a.75.75 0 0 1 1.5 0v.5a1.25 1.25 0 1 0 2.5 0v-.773l-1.651-2.477h-6.698Zm7.348 5.989a2.741 2.741 0 0 1-2.178-.777 2.493 2.493 0 0 1-1.822.788 2.493 2.493 0 0 1-1.822-.789 2.741 2.741 0 0 1-2.178.778v3.761c0 .138.112.25.25.25h2.25v-2a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v2h2.25a.25.25 0 0 0 .25-.25v-3.761Z"
  }));
};
SvgStoreMajor.displayName = "StoreMajor";

exports.SvgStoreMajor = SvgStoreMajor;
